import { createSlice, createSelector } from '@reduxjs/toolkit'

const initialState = {
  currency: {},
  loading: false,
  error: null,
}

const currency = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    requestCurrency(state) {
      state.loading = true
    },
    successCurrency(state, { payload }) {
      state.loading = false
      state.error = null
      state.currency = payload?.currency
    },
    failureCurrency(state, { payload }) {
      state.loading = false
      state.error = payload?.data
    }
  }
})

export const fetchCurrency = ({ getFromCache = true, storage = sessionStorage } = {}) => async (dispatch, getState, { api }) => {
  try {
    dispatch(requestCurrency())
      let currency = undefined;
      let fromCache = false;
      let isStorageTime = false;
      let time = null;

      if (getFromCache) {
        currency = JSON.parse(await storage.getItem('currency'));
        fromCache = !!currency;
      }

      const now = new Date().getHours();

      if (currency && currency.result !== 'error') {
        isStorageTime = currency.time && (currency.time > now || currency.time < (now - 2)) || !currency.time
      }

      if (!currency || currency.result === 'error' || isStorageTime){
        currency = await api.currencyRates()
        time = now
      }

      if (currency && currency.result !== 'error') {
        dispatch(successCurrency({ currency }))
        if (!fromCache) {
          await storage.setItem('currency', JSON.stringify({ ...currency, time: time ? time : currency.time }));
        }
      } else {
        dispatch(failureCurrency({ data: currency }))
      }    
  } catch(e) {
    dispatch(failureCurrency({ data: e.toString() }))
  }
}

export const getCurrency = createSelector(
  state => state.currency,
  data => data.currency
)

export const { requestCurrency, successCurrency, failureCurrency } = currency.actions

export default currency.reducer
